/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React from 'react';
import { ITableCellComponentProps } from '../types/tableVisualizationTypes';

function classNames(): { [_: string]: string } {
    return {
        boolean: 'jr jr-mDatatable-cell-text',
        byte: 'jr jr-mDatatable-cell-number',
        short: 'jr jr-mDatatable-cell-number',
        integer: 'jr jr-mDatatable-cell-number',
        long: 'jr jr-mDatatable-cell-number',
        bigInteger: 'jr jr-mDatatable-cell-number',
        float: 'jr jr-mDatatable-cell-number',
        double: 'jr jr-mDatatable-cell-number',
        bigDecimal: 'jr jr-mDatatable-cell-number',
        string: 'jr jr-mDatatable-cell-text',
        date: 'jr jr-mDatatable-cell-date',
        timestamp: 'jr jr-mDatatable-cell-date',
        time: 'jr jr-mDatatable-cell-date',
        loading: 'jr jr-mDatatable-cell-loading'
    }
}

export function cellFactory(props: ITableCellComponentProps) {
    const { title, contentType } = props;
    let className = 'jr jr-mDatatable-cell-text';
    let aggregationSpan;

    let specificClass = '';
    if (contentType && classNames()[contentType]) {
        specificClass = classNames()[contentType];
    }
    if (specificClass) {
        className = specificClass;
    }

    if (contentType === 'loading') {
        className += ' jr-mSkeleton-body-cell-content';
        return (
            <div
                className={className}
                style={{
                    width: '50%', top: '8px'
                }}
            >
                &nbsp;
            </div>
        )
    }

    if (props.aggregationLabel) {
        aggregationSpan = <span>{`${props.aggregationLabel}:`}</span>;
    }

    return (
        <div className={className}>{aggregationSpan}{title}</div>
    );
}

export function TableCellComponent(props: ITableCellComponentProps) {
    const {
        width, colSpan, cellRef, cellIndex, contentType, eventListener
    } = props;

    let className = 'jr-mDatatable-cell jr-mDatatable-cell-hyperlink jr jr-jHyperLink';
    if (contentType === 'loading') {
        className = 'jr-mSkeleton-body-cell jr';
    }

    return (
        <td
            ref={cellRef}
            tabIndex={-1}
            className={className}
            colSpan={colSpan !== undefined ? colSpan : 1}
            style={{
                maxWidth: (width === 0 ? '100%' : width),
                minWidth: (width === 0 ? '100%' : width),
                verticalAlign: 'middle'
            }}
            data-cell-index={cellIndex}
            onFocus={() => {}}
            onBlur={() => {}}
            onClick={eventListener}
            onMouseOver={eventListener}
            onMouseEnter={eventListener}
            onMouseOut={eventListener}
        >
            <div
                className="jr-mDatatable-cell-wrapper jr"
                style={{
                    width: '100%'
                }}
            >
                {cellFactory(props)}
            </div>
        </td>
    );
}
